import React from "react";
import { Stage, Layer } from 'react-konva';
import CloudsGroup from './CloudsGroup'


export class Clouds extends React.Component {
  render() {
    // Stage is a div container
    // Layer is actual canvas element (so you may have several canvases in the stage)
    // And then we have canvas shapes inside athe Layer
    const sw = window.innerWidth
    //const sh = window.innerHeight
    const sh = 250
    //const halfsw = sw / 2

    const stageStyle = {
      position: 'absolute',
      left: `0px`,
    }

    return (
      <Stage width={sw} height={sh} style={stageStyle}>
        <Layer>
          <CloudsGroup />
        </Layer>
      </Stage>
    );
  }
}
